import { render, staticRenderFns } from "./CorporationsList.vue?vue&type=template&id=52bbf09c"
import script from "./CorporationsList.vue?vue&type=script&lang=js"
export * from "./CorporationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports